export enum CheckoutSubnavigationItems {
    SALE = 'sale',
    RESERVATION = 'reservation',
}
